import { Button, Status, Text, Title } from '@gjensidige/builders-components';

const TempPage = () => {
  return (
    <Status variant={500}>
      <Title>Siden finnes ikke</Title>
      <Text>
        Siden du har bedt om finnes ikke lenger på denne adressen. <br /> Mulige årsaker kan være at
        siden er slettet eller flyttet, eller at adressen er tastet inn feil.
      </Text>
      <Button href="https://www.gjensidige.no">Gå til forsiden</Button>
    </Status>
  );
};

export default TempPage;
